import { createStyles, makeStyles } from '@material-ui/core/styles';

interface StyleProps {
  isMobile: boolean;
}

const useStyles = makeStyles(() =>
  createStyles({
    divCard: {
      display: ({ isMobile }: StyleProps) => (isMobile ? 'contents' : 'flex'),
      padding: 40,
      justifyContent: 'space-around',
    },
    grid: {
      width: ({ isMobile }: StyleProps) => (isMobile ? '100%' : 'auto'),
    },
    card: {
      width: ({ isMobile }: StyleProps) => (isMobile ? '100%' : '936px'),
      height: '905px',
      background: `transparent linear-gradient(180deg, #2D6DF6 0%, #0133A0 100%) 0% 0% no-repeat padding-box`,
      boxShadow: '0px 3px 6px #00000029',
      borderRadius: ({ isMobile }: StyleProps) => (isMobile ? 0 : '20px'),
      opacity: 1,
      margin: '40px 0',
      display: 'grid',
    },
    divIframe: {
      position: 'relative',
      width: '95%',
      minHeight: '100px',
      margin: ({ isMobile }: StyleProps) => (isMobile ? '12px' : '20px'),
      overflow: 'auto',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: ({ isMobile }: StyleProps) => (isMobile ? '289px' : '704px'),
    },
    labelReceipt: {
      fontFamily: 'SuraSans-Extranegrita',
      fontSize: '26px',
      color: '#FFFFFF',
      textAlign: ({ isMobile }: StyleProps) => (isMobile ? 'center' : 'left'),
      padding: ({ isMobile }: StyleProps) => (isMobile ? '20px 0' : 0),
    },
    divPDF: {
      position: 'relative',
      width: '95%',
      minHeight: '100%',
      margin: '20px',
      overflow: 'auto',
    },
    labelReady: {
      fontFamily: 'SuraSans-Negrita',
      fontSize: '32px',
      color: '#F8F8F8',
    },
    divRight: {
      padding: '40px 20px',
    },
    labelPolicy: {
      fontFamily: 'SuraSans-Regular',
      fontSize: '16px',
      color: '#FFFFFF',
      width: ({ isMobile }: StyleProps) => (isMobile ? 'auto' : '180px'),
    },
    divNumberPolicy: {
      height: 'auto',
      padding: '10px 0px 0px 20px',
      borderRadius: '15px',
      marginTop: '20px',
    },
    divReceipts: {
      display: 'flex',
      flexDirection: 'column',
      height: 'auto',
      maxHeight: '370px',
      gap: '2px',
      overflow: 'scroll',
    },
    labelNumberPolicy: {
      fontFamily: 'SuraSans-Negrita',
      fontSize: '18px',
      color: '#FFFFFF',
    },
    divButtons: {
      padding: '40px',
      display: ({ isMobile }: StyleProps) => (isMobile ? 'flex' : 'grid'),
      justifyContent: 'space-around',
      width: ({ isMobile }: StyleProps) => (isMobile ? '100%' : 'auto'),
      alignItems: 'baseline',
    },
    sendButton: {
      fontFamily: 'SuraSans-Seminegrita',
      fontSize: '15px',
      color: '#FFFFFF',
      background: 'none',
    },
    downloadButton: {
      marginTop: 30,
      fontFamily: 'SuraSans-Seminegrita',
      fontSize: '16px',
      color: '#0033A0',
      background: '#E3E829',
      borderRadius: 28,
      width: '164px',
      height: '48px',
      '&:hover': {
        background: '#E3E829',
      },
    },
    divBottom: {
      background: '#00003F',
      borderRadius: ({ isMobile }: StyleProps) => (isMobile ? 0 : '0px 0px 20px 20px'),
      width: ({ isMobile }: StyleProps) => (isMobile ? '100%' : '936px'),
      height: ({ isMobile }: StyleProps) => (isMobile ? '88px' : '79px'),
      marginTop: ({ isMobile }: StyleProps) => (isMobile ? '-4px' : '-38px'),
      justifyContent: 'space-around',
      alignItems: 'center',
    },
    labelThanks: {
      fontFamily: 'SuraSans-Fina',
      fontSize: '16px',
      color: '#FFFFFF',
    },
    labelSure: {
      fontFamily: 'SuraSans-Regular',
      fontSize: '20px',
      color: '#FFFFFF',
      marginTop: '-10px',
    },
    labelSuraLarge: {
      fontSize: '28px',
    },
    labelHashtag: {
      fontFamily: 'SuraSans-Fina',
      fontSize: '20px',
      color: '#FFFFFF',
      marginLeft: ({ isMobile }: StyleProps) => (isMobile ? '20px' : '0'),
    },
    buttonPayOther: {
      fontFamily: 'SuraSans-Seminegrita',
      fontSize: '16px',
      color: '#2D6DF6',
      background: 'none',
      '&:hover': {
        background: 'none',
      },
    },
    buttonMoreSura: {
      width: '255px',
      height: '40px',
      border: '1px solid #0133A0',
      opacity: 1,
      borderRadius: 20,
      fontFamily: 'SuraSans-Seminegrita',
      fontSize: '16px',
      color: '#0133A0',
      background: 'none',
      '&:hover': {
        background: 'none',
      },
    },
    divButtonsOther: {
      width: ({ isMobile }: StyleProps) => (isMobile ? '100%' : '936px'),
      display: ({ isMobile }: StyleProps) => (isMobile ? 'grid' : 'flex'),
      justifyContent: ({ isMobile }: StyleProps) => (isMobile ? 'center' : 'space-between'),
      padding: '0 20px',
    },
    divReceipt: {
      width: ({ isMobile }: StyleProps) => (isMobile ? '100%' : '980px'),
    },
    divText: {
      textAlign: ({ isMobile }: StyleProps) => (isMobile ? 'center' : 'left'),
    },
    progress: {
      color: '#FFFFFF',
    },
  }),
);

export default useStyles;
